import React, { Component } from 'react';
import PropTypes from 'prop-types';
import WindowBox from 'components/WindowBox';
import FormItem, { INPUT_TYPE } from '../../../../components/FormItem';
import { reduxForm } from 'redux-form';
import { FormattedMessage, intlShape, injectIntl, defineMessages } from 'react-intl';
import { isInvalidID } from 'containers/App/screens/Foundation/utils/verify';

const messages = defineMessages({
  isRequired: {
    id: 'SH_FieldRequired',
    defaultMessage: '欄位為必填',
  },
  fileSizeLimit: {
    id: 'SH_FileSizeLimit',
    defaultMessage: '大小限制為 {0}',
  },
  emptyData: {
    id: 'SH_OpenFileError01',
    defaultMessage: '不可上傳空白檔案',
  },
  formatError: {
    id: 'SH_NotSupportFormat',
    defaultMessage: '格式錯誤',
  },
});

class NewRecordApplyForm extends Component {
  onAttachFileUpload(event) {
    event.preventDefault();
    if (!event.target.files || event.target.files.length === 0) {
      return;
    }
    this.props.fields.attachFile.onChange(event.target.files[0]);
  }

  renderArmyStatusElem() {
    const {
      militaryService,
      fields: {
        armyStatus,
      },
    } = this.props;

    const armyFieldSetting = this.props.fieldSettings['0060'];

    if (armyFieldSetting.isDisplay === false) {
      return '';
    }

    return (
      <FormItem
        itemName="armyStatus"
        itemValue={armyStatus.value}
        labelText={<FormattedMessage key="1" id="SH_MilitaryServiceStatus" defaultMessage="兵役狀態" />}
        inputType={INPUT_TYPE.RADIO}
        onChange={armyStatus.onChange}
        clearable={false}
        require={armyFieldSetting.required}
        options={
          militaryService.map((service) => {
            return {
              label: service.text,
              value: service.value,
            };
          })
        }
      />
    );
  }

  renderArmyDetailElems() {
    const {
      arms,
      fields: {
        armyStatus,
        armyType,
        armyStart,
        armyEnd,
      },
    } = this.props;

    const armyFieldSetting = this.props.fieldSettings['0060'];

    if (armyFieldSetting.isDisplay === false || armyStatus.value === '2' || armyStatus.value === '3') {
      return '';
    }

    return (
      <div>
        <FormItem
          itemName="armyType"
          itemValue={armyType.value}
          labelText={<FormattedMessage key="1" id="SH_MilitaryServiceType" defaultMessage="役別" />}
          inputType={INPUT_TYPE.SELECT}
          require={armyFieldSetting.required}
          onChange={armyType.onChange}
          options={
            arms.map((armType) => {
              return {
                label: armType.text,
                value: armType.value,
              };
            })
          }
        />
        <FormItem
          itemName="armyStart"
          itemValue={armyStart.value}
          labelText={<FormattedMessage key="1" id="SH_MilitaryServiceStartTime" defaultMessage="兵役開始時間" />}
          inputType={INPUT_TYPE.DATEPICKER}
          allowEmpty
          require={armyFieldSetting.required}
          onChange={armyStart.onChange}
        />
        <FormItem
          itemName="armyEnd"
          itemValue={armyEnd.value}
          labelText={<FormattedMessage key="1" id="SH_MilitaryServiceEndTime" defaultMessage="兵役結束時間" />}
          inputType={INPUT_TYPE.DATEPICKER}
          allowEmpty
          require={armyFieldSetting.required}
          onChange={armyEnd.onChange}
        />
      </div>
    );
  }

  renderArmyExemptReasonElem() {
    const exemptReason = this.props.fields.exemptReason;
    const armyStatus = this.props.fields.armyStatus;
    const armyFieldSetting = this.props.fieldSettings['0060'];

    if (armyFieldSetting.isDisplay === false || armyStatus.value !== '2') {
      return '';
    }
    return (
      <FormItem
        itemName="exemptReason"
        itemValue={exemptReason.value}
        labelText={<FormattedMessage key="1" id="SH_WaivedReason" defaultMessage="免役原因" />}
        inputType={INPUT_TYPE.TEXT}
        require={armyFieldSetting.required}
        onChange={exemptReason.onChange}
      />
    );
  }

  render() {
    const {
      genders,
      maritalStatusOptions,
      nationality,
      iDTypes,
      fieldSettings,
      onClose,
      submitting,
      error,
      fields: {
        firstName,
        lastName,
        englishName,
        nation,
        gender,
        iDType,
        iDNumber,
        iDExpiryDate,
        iDType2,
        iDNumber2,
        iDExpiryDate2,
        iDType3,
        iDNumber3,
        iDExpiryDate3,
        entryTime,
        birthday,
        maritalStatus,
        attachFile,
        reasons,
      },
    } = this.props;
    return (
      <WindowBox
        title={<FormattedMessage key="1" id="FD_RequestEditEmployeeData" defaultMessage="申請修改資料" />}
        titleBackgroundColor="#157FCC"
        onClose={onClose}
      >
        <form
          className="form-horizontal"
          style={{ padding: 10 }}
          onSubmit={this.props.handleSubmit}
        >
          <FormItem
            itemName="lastName"
            itemValue={lastName.value}
            labelText={<FormattedMessage key="1" id="SH_LastName" defaultMessage="姓" />}
            inputType={INPUT_TYPE.TEXT}
            require
            onChange={lastName.onChange}
            errorMessage={lastName.touched && lastName.error}
          />
          <FormItem
            itemName="firstName"
            itemValue={firstName.value}
            labelText={<FormattedMessage key="1" id="SH_FirstName" defaultMessage="名" />}
            inputType={INPUT_TYPE.TEXT}
            require
            onChange={firstName.onChange}
            errorMessage={firstName.touched && firstName.error}
          />
          {
            fieldSettings['0040'].isDisplay && (
              <FormItem
                itemName="englishName"
                itemValue={englishName.value}
                labelText={<FormattedMessage key="1" id="SH_EnglishName" defaultMessage="英文姓名" />}
                inputType={INPUT_TYPE.TEXT}
                require={fieldSettings['0040'].required}
                onChange={englishName.onChange}
                errorMessage={englishName.touched && englishName.error}
              />
            )
          }
          <FormItem
            itemName="nation"
            itemValue={nation.value}
            labelText={<FormattedMessage key="1" id="SH_Nationality" defaultMessage="國藉" />}
            inputType={INPUT_TYPE.SELECT}
            require
            onChange={nation.onChange}
            searchable
            clearable={false}
            errorMessage={nation.touched && nation.error}
            options={
              nationality.map((nationOption) => {
                return {
                  label: nationOption.text,
                  value: nationOption.value,
                };
              })
            }
          />
          <FormItem
            itemName="gender"
            itemValue={gender.value}
            labelText={<FormattedMessage key="1" id="SH_Gender" defaultMessage="性別" />}
            inputType={INPUT_TYPE.RADIO}
            require
            onChange={gender.onChange}
            clearable={false}
            errorMessage={gender.touched && gender.error}
            options={
              genders.map((sex) => {
                return {
                  label: sex.text,
                  value: sex.value,
                };
              })
            }
          />
          { this.renderArmyStatusElem() }
          { this.renderArmyDetailElems() }
          { this.renderArmyExemptReasonElem() }
          <FormItem
            itemName="iDType"
            itemValue={iDType.value ? iDType.value.toString() : 1}
            labelText={<FormattedMessage key="1" id="SH_IdentificationDocumentType" defaultMessage="識別證件類型" />}
            inputType={INPUT_TYPE.SELECT}
            require
            onChange={iDType.onChange}
            clearable={false}
            errorMessage={iDType.touched && iDType.error}
            options={
              iDTypes.map((type) => {
                return {
                  label: type.text,
                  value: type.value,
                };
              })
            }
          />
          <FormItem
            itemName="iDNumber"
            itemValue={iDNumber.value}
            labelText={<FormattedMessage key="1" id="SH_IdentificationDocumentNumber" defaultMessage="識別證件號碼" />}
            inputType={INPUT_TYPE.TEXT}
            require
            errorMessage={iDNumber.touched && iDNumber.error}
            onChange={iDNumber.onChange}
          />
          <FormItem
            itemName="iDExpiryDate"
            itemValue={iDExpiryDate.value}
            labelText={<FormattedMessage key="1" id="FD_IDDocExpiryDate" defaultMessage="識別證件過期日{0}" values={{ 0: '' }} />}
            inputType={INPUT_TYPE.DATEPICKER}
            allowEmpty
            errorMessage={iDExpiryDate.touched && iDExpiryDate.error}
            onChange={iDExpiryDate.onChange}
          />
          <FormItem
            itemName="iDType2"
            itemValue={iDType2.value}
            labelText={<FormattedMessage key="1" id="FD_IDDocType" defaultMessage="識別證件類型{0}" values={{ 0: '2' }} />}
            inputType={INPUT_TYPE.TEXT}
            errorMessage={iDType2.touched && iDType2.error}
            onChange={iDType2.onChange}
          />
          <FormItem
            itemName="iDNumber2"
            itemValue={iDNumber2.value}
            labelText={<FormattedMessage key="1" id="FD_IDDocNumber" defaultMessage="識別證件號碼{0}" values={{ 0: '2' }} />}
            inputType={INPUT_TYPE.TEXT}
            errorMessage={iDNumber2.touched && iDNumber2.error}
            onChange={iDNumber2.onChange}
          />
          <FormItem
            itemName="iDExpiryDate2"
            itemValue={iDExpiryDate2.value}
            labelText={<FormattedMessage key="1" id="FD_IDDocExpiryDate" defaultMessage="識別證件過期日{0}" values={{ 0: '2' }} />}
            inputType={INPUT_TYPE.DATEPICKER}
            allowEmpty
            errorMessage={iDExpiryDate2.touched && iDExpiryDate2.error}
            onChange={iDExpiryDate2.onChange}
          />
          <FormItem
            itemName="iDType3"
            itemValue={iDType3.value}
            labelText={<FormattedMessage key="1" id="FD_IDDocType" defaultMessage="識別證件類型{0}" values={{ 0: '3' }} />}
            inputType={INPUT_TYPE.TEXT}
            errorMessage={iDType3.touched && iDType3.error}
            onChange={iDType3.onChange}
          />
          <FormItem
            itemName="iDNumber3"
            itemValue={iDNumber3.value}
            labelText={<FormattedMessage key="1" id="FD_IDDocNumber" defaultMessage="識別證件號碼{0}" values={{ 0: '3' }} />}
            inputType={INPUT_TYPE.TEXT}
            errorMessage={iDNumber3.touched && iDNumber3.error}
            onChange={iDNumber3.onChange}
          />
          <FormItem
            itemName="iDExpiryDate3"
            itemValue={iDExpiryDate3.value}
            labelText={<FormattedMessage key="1" id="FD_IDDocExpiryDate" defaultMessage="識別證件過期日{0}" values={{ 0: '3' }} />}
            inputType={INPUT_TYPE.DATEPICKER}
            allowEmpty
            errorMessage={iDExpiryDate3.touched && iDExpiryDate3.error}
            onChange={iDExpiryDate3.onChange}
          />
          <FormItem
            itemName="entryTime"
            itemValue={entryTime.value}
            labelText={<FormattedMessage key="1" id="SH_DateOfEntry" defaultMessage="入境時間" />}
            inputType={INPUT_TYPE.DATEPICKER}
            allowEmpty
            errorMessage={entryTime.touched && entryTime.error}
            onChange={entryTime.onChange}
          />
          <FormItem
            itemName="birthday"
            itemValue={birthday.value}
            labelText={<FormattedMessage key="1" id="SH_DateOfBirth" defaultMessage="生日" />}
            inputType={INPUT_TYPE.DATEPICKER}
            allowEmpty
            require
            errorMessage={birthday.touched && birthday.error}
            onChange={birthday.onChange}
          />
          {
            fieldSettings['0100'].isDisplay && (
              <FormItem
                itemName="maritalStatus"
                itemValue={maritalStatus.value}
                labelText={<FormattedMessage key="1" id="SH_MaterialStatus" defaultMessage="婚姻狀態" />}
                inputType={INPUT_TYPE.RADIO}
                errorMessage={maritalStatus.touched && maritalStatus.error}
                require={fieldSettings['0100'].required}
                onChange={maritalStatus.onChange}
                options={
                  maritalStatusOptions.map((status) => {
                    return {
                      label: status.text,
                      value: status.value,
                    };
                  })
                }
              />
            )
          }
          <hr />
          <FormItem
            itemName="reasons"
            itemValue={reasons.value}
            labelText={<FormattedMessage id="SH_ModifyReason" defaultMessage="修改原因" />}
            inputType={INPUT_TYPE.TEXT}
            require
            errorMessage={reasons.touched && reasons.error}
            onChange={reasons.onChange}
          />
          <FormItem
            itemName="attachFile"
            itemValue={attachFile.value && attachFile.value.filename}
            labelText={<FormattedMessage id="FD_UploadCertificateFile" defaultMessage="請檢附證明文件" />}
            inputType={INPUT_TYPE.FILE}
            errorMessage={attachFile.touched && attachFile.error}
            onChange={this.onAttachFileUpload.bind(this)}
            accept=".doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt,.rtf,.pdf,.zip,.7z,.rar"
          />
          <div className="col-sm-8 col-sm-offset-4">
            <p className="help-block basic__helpBlock">* <FormattedMessage id="SH_FileLimit01" defaultMessage="格式限Microsoft Office文件、TXT純文字、壓縮檔、PDF" /></p>
            <p className="help-block basic__helpBlock">* {this.props.intl.formatMessage(messages.fileSizeLimit, { 0: '300KB' })}</p>
          </div>
          {
            error && (
              <div className="alert alert-danger col-sm-8 col-sm-offset-4">{error}</div>
            )
          }
          <div className="form-group">
            <div className="col-sm-offset-4 col-sm-8">
              <div className="pull-right">
                <button
                  style={{
                    marginRight: 10,
                  }}
                  type="submit"
                  className="btn btn-primary"
                  disabled={submitting}
                >
                  {
                    submitting ? <i className="fa fa-spinner fa-spin"></i> :
                    <FormattedMessage id="SH_Confirm" defaultMessage="確定" />
                  }
                </button>
                <button className="btn btn-default" onClick={onClose}>
                  <FormattedMessage id="SH_Cancel" defaultMessage="取消" />
                </button>
              </div>
            </div>
          </div>
        </form>
      </WindowBox>
    );
  }
}

NewRecordApplyForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  genders: PropTypes.array.isRequired,
  arms: PropTypes.array.isRequired,
  nationality: PropTypes.array.isRequired,
  militaryService: PropTypes.array.isRequired,
  maritalStatusOptions: PropTypes.array.isRequired,
  iDTypes: PropTypes.array.isRequired,
  fields: PropTypes.object.isRequired,
  fieldSettings: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  error: PropTypes.string,
  intl: intlShape.isRequired,
};

export const fields = [
  'firstName',
  'lastName',
  'englishName',
  'nation',
  'gender',
  'armyStatus',
  'armyType',
  'armyStart',
  'armyEnd',
  'exemptReason',
  'iDType',
  'iDNumber',
  'iDExpiryDate',
  'iDType2',
  'iDNumber2',
  'iDExpiryDate2',
  'iDType3',
  'iDNumber3',
  'iDExpiryDate3',
  'entryTime',
  'birthday',
  'maritalStatus',
  'attachFile',
  'reasons',
  'action',
];

export const formName = 'foundation/mydata/basicinfo/NewRecordApplyForm';

function isEmptyString(source) {
  if (source === null || source === undefined) {
    return true;
  }
  const target = typeof source === 'number' ? source.toString() : source;
  if (target.length === 0) {
    return true;
  }
  return false;
}

function validate(value, props) {
  const fieldSettings = props.fieldSettings;

  const errors = {};

  if (isEmptyString(value.lastName)) {
    errors.lastName = props.intl.formatMessage(messages.isRequired);
  }

  if (isEmptyString(value.firstName)) {
    errors.firstName = props.intl.formatMessage(messages.isRequired);
  }

  if (fieldSettings['0040'].required && isEmptyString(value.englishName)) {
    errors.englishName = props.intl.formatMessage(messages.isRequired);
  }

  if (isEmptyString(value.nation)) {
    errors.nation = props.intl.formatMessage(messages.isRequired);
  }

  if (isEmptyString(value.gender)) {
    errors.gender = props.intl.formatMessage(messages.isRequired);
  }

  if (fieldSettings['0060'].required && isEmptyString(value.armyStatus)) {
    errors.armyStatus = props.intl.formatMessage(messages.isRequired);
  }

  if (fieldSettings['0060'].required && value.armyStatus !== '2' && isEmptyString(value.armyType)) {
    errors.armyType = props.intl.formatMessage(messages.isRequired);
  }

  if (fieldSettings['0060'].required && value.armyStatus !== '2' && isEmptyString(value.armyStart)) {
    errors.armyStart = props.intl.formatMessage(messages.isRequired);
  }

  if (fieldSettings['0060'].required && value.armyStatus !== '2' && isEmptyString(value.armyEnd)) {
    errors.armyEnd = props.intl.formatMessage(messages.isRequired);
  }

  if (fieldSettings['0060'].required && value.armyStatus === '2' && isEmptyString(value.exemptReason)) {
    errors.exemptReason = props.intl.formatMessage(messages.isRequired);
  }
  if (isEmptyString(value.iDType)) {
    errors.iDType = props.intl.formatMessage(messages.isRequired);
  }

  if (isEmptyString(value.iDType) === false && (/1|3/).test(value.iDType) && isInvalidID(value.iDNumber, String(value.iDType) === '3')) {
    errors.iDNumber = props.intl.formatMessage(messages.formatError);
  }

  if (isEmptyString(value.birthday)) {
    errors.birthday = props.intl.formatMessage(messages.isRequired);
  }

  if (fieldSettings['0100'].required && isEmptyString(value.maritalStatus)) {
    errors.maritalStatus = props.intl.formatMessage(messages.isRequired);
  }

  if (isEmptyString(value.reasons)) {
    errors.reasons = props.intl.formatMessage(messages.isRequired);
  }

  if (value.attachFile && value.attachFile.size === 0) {
    errors.attachFile = props.intl.formatMessage(messages.emptyData);
  }

  if (value.attachFile && value.attachFile.size > 300000) {
    errors.attachFile = props.intl.formatMessage(messages.fileSizeLimit, { 0: '300KB' });
  }

  return errors;
}

NewRecordApplyForm = reduxForm({
  form: formName,
  fields,
  validate,
})(NewRecordApplyForm);

export default injectIntl(NewRecordApplyForm);



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/MyData/screens/BasicInfo/components/NewRecordApplyForm/index.js
 **/